import { useLocation } from "react-router-dom";
import SubmittalLog from "./submittal-log";
import { getSubmittalLogViewFromPath } from "./submittal-log-view";

function SubmittalLogLandingPage() {
  const location = useLocation();
  const logView = getSubmittalLogViewFromPath(location.pathname);

  // Remount when switching dropdown categories so column/saved-view state does
  // not bleed across Submittal Log, Voided, and Deleted (same as untracked).
  return <SubmittalLog key={logView} logView={logView} />;
}

export default SubmittalLogLandingPage;
